import { Input } from '@/components/ui/input';
import { useId } from 'react';
import { CustomFieldHelperText } from './custom-field-helper-text';
import { CustomFieldLabel } from './custom-field-label';
import type { CustomFieldProps } from './types';
import { CustomFieldWrapper } from './custom-field';

const decimalRegex = /^-?\d*\.?\d*$/;

export function CustomFloatField({
  title,
  placeholder,
  onValueChange,
  value,
  disabled,
  required,
  description,
  error,
}: CustomFieldProps) {
  const id = useId();
  return (
    <CustomFieldWrapper>
      <CustomFieldLabel required={required} htmlFor={id}>
        {title}
      </CustomFieldLabel>
      <Input
        id={id}
        step={0.1}
        type='text'
        value={value || ''}
        disabled={disabled}
        onChange={(e) => {
          const value = e.target.value;
          if (decimalRegex.test(value) || value === '') {
            onValueChange?.(value);
          }
        }}
        placeholder={placeholder || title}
      />
      <CustomFieldHelperText error={error} description={description} />
    </CustomFieldWrapper>
  );
}
